import { isArray } from 'xe-utils'
import ApiUrlConstants from '@/common/ApiUrlConstants'
import RestService from '@/common/RestService'
import CACA1030RequestModel from '@/api/data/CAC/CACA1030/CACA1030RequestModel'
import CACA1030ResponseModel from '@/api/data/CAC/CACA1030/CACA1030ResponseModel'
import Moment from 'moment'
import { FormatConstants } from '@/common/FormatConstants'
import CommonUtil from '@/common/utils/CommonUtil'

export default class CACG1030Service {
  /**
   * CACA1030 API呼出処理
   * @returns CACA1030ResponseModel
   */
  public async callAPICACA1030(
    prdSelectedArr: any
  ): Promise<CACA1030ResponseModel> {
    const caca1030RequestModel = new CACA1030RequestModel()
    caca1030RequestModel.productIndexLst = prdSelectedArr

    const caca1030ResponseModel: CACA1030ResponseModel = <
      CACA1030ResponseModel
    > await RestService.post(ApiUrlConstants.CACA1030, caca1030RequestModel)
    return caca1030ResponseModel
  }

  /**
   * チャートのデータを作成する
   * @param cacg1030ViewModel
   * @returns dataReturn
   */
  public createDataChart(cacg1030ViewModel): Array<any> {
    const dataReturn = cacg1030ViewModel.hikakuProductLst?.map(
      (itemHikakuProduct) => {
        let dataChart = []
        if (itemHikakuProduct.monthlyChartLst) {
          itemHikakuProduct.monthlyChartLst =
            itemHikakuProduct.monthlyChartLst.reverse()
          dataChart = itemHikakuProduct.monthlyChartLst?.map(
            (itemMonthlyChart) => {
              return [
                Date.parse(
                  Moment(itemMonthlyChart.monthlyChartBaseDate).format(
                    'YYYY/MM/28'
                  )
                ),
                CommonUtil.roundNumber(
                  itemMonthlyChart.monthlyChartValue,
                  FormatConstants.INVEST_WITHOUT_UNIT
                )
              ]
            }
          )
        }
        return {
          name: itemHikakuProduct.productNameInformal,
          data: dataChart
        }
      }
    )

    return dataReturn
  }

  /**
   * リストデータチャートの変換
   * @param dataConvert 変換するリストデータチャート
   * @param startIndex インデックス計算開始データ
   * @returns returnData
   */
  public convertDataChart(dataConvert, startIndex) {
    const returnData = JSON.parse(JSON.stringify(dataConvert))
    if (!isArray(returnData)) {
      return []
    }
    returnData.forEach((dataChart) => {
      if (CommonUtil.isNotNullArray(dataChart.data, [1])) {
        let currentIndex = startIndex
        for (
          currentIndex;
          currentIndex < dataChart.data.length;
          currentIndex++
        ) {
          if (
            dataChart.data[currentIndex][1] === null ||
            dataChart.data[currentIndex][1] === 0
          ) {
            dataChart.data[currentIndex][1] = null
          } else {
            break
          }
        }

        const ratio =
          currentIndex < dataChart.data.length
            ? 100 / dataChart.data[currentIndex][1]
            : 1

        for (let index = 0; index < dataChart.data.length; index++) {
          if (currentIndex === dataChart.data.length) {
            dataChart.data[index][1] = null
          } else {
            if (dataChart.data[index][1] !== null) {
              dataChart.data[index][1] = dataChart.data[index][1] * ratio
            }
          }
        }
      }
    })
    return returnData
  }
}
